/**
 * Implementation of IFloodgateTelemetryLogger for Web SDK
 */

import * as Api from "@ms-ofb/officefloodgatecore/dist/src/Api/Api";
import * as Logging from "../Logging/Logging";

export default class IFloodgateTelemetryLogger implements Api.IFloodgateTelemetryLogger {
	/**
	 * Log that a survey's trigger was met.
	 * @param campaignId Id of the campaign the survey belongs to.
	 * @param surveyId Id of the survey.
	 * @param surveyType Type of the survey.
	 */
	public log_TriggerMet(campaignId: string, surveyId: string, surveyType: Api.ISurvey.Type): void {
		Logging.getLogger().logEvent(Logging.EventIds.Survey.Floodgate.TriggerMet.VALUE,
			{
				CampaignId: campaignId,
				SurveyId: surveyId,
				SurveyType: surveyType,
			});
	}

	/**
	 * Log that a user was selected(nominated) for a survey
	 * @param campaignId Id of the campaign the survey belongs to.
	 * @param surveyId Id of the survey.
	 * @param surveyType Type of the survey.
	 */
	public log_UserSelected(campaignId: string, surveyId: string, surveyType: Api.ISurvey.Type): void {
		Logging.getLogger().logEvent(Logging.EventIds.Survey.Floodgate.UserSelected.VALUE,
			{
				CampaignId: campaignId,
				SurveyId: surveyId,
				SurveyType: surveyType,
			});
	}

	/**
	 * Log that campaign definitions failed to load.
	 * @param errorMessage error message
	 */
	public log_CampaignLoad_Failed(errorMessage: string): void {
		Logging.getLogger().logEvent(Logging.EventIds.Survey.Floodgate.CampaignLoad.Failed.VALUE,
			{
				ErrorMessage: errorMessage,
			});
	}
}
